import { HttpParams } from '@angular/common/http';
import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import moment from 'moment';
import { User } from '../../../pages/admin/services/admin.service';
import { EmployeeService } from '../../../pages/employee/services/employee.service';
import { UtilityService } from '../../../core/services/utility.service'

@Component({
  selector: 'app-paperless-settings-modal',
  templateUrl: './paperless-settings-modal.component.html',
  styleUrls: ['./paperless-settings-modal.component.css']
})
export class PaperlessSettingsModalComponent implements OnInit{
  @Input() user: User;
  @Input() settings: {
    showPay: boolean
    showW2: boolean
    show1095: boolean
  };
  consentPaystubsModifiedDisplay: string;
  consentW2ModifiedDisplay: string;
  consentC1095ModifiedDisplay: string;
  updatingSettings: boolean = false;
  settingsWereChanged: boolean = false;

  constructor(
    private activeModal: NgbActiveModal,
    private employeeService: EmployeeService,
    private readonly utilityService: UtilityService) {

  }

  ngOnInit () {
    if (this.user.ConsentPaystubsLastModified) {
      this.consentPaystubsModifiedDisplay = this.utilityService.formatDate(this.user.ConsentPaystubsLastModified, 'D', 'M', 'YYYY');
    }
    if (this.user.ConsentW2T4LastModified) {
      this.consentW2ModifiedDisplay = this.utilityService.formatDate(this.user.ConsentW2T4LastModified, 'D', 'M', 'YYYY');
    }
    if (this.user.ConsentACA1095LastModified) {
      this.consentC1095ModifiedDisplay = this.utilityService.formatDate(this.user.ConsentACA1095LastModified, 'D', 'M', 'YYYY');
    }
  }

  updateSettings () {
    const params = new HttpParams()
      .set('consentPaystubs', this.user.ConsentPaystubs.toString())
      .set('consentW2T4', this.user.ConsentW2T4.toString())
      .set('consentACA1095', this.user.ConsentACA1095.toString())
      .set('userKeyID', this.user.UserKeyID.toString())
      .set('optOutSMS', this.user.OptOutSMS.toString())
    this.updatingSettings = true;
    this.employeeService.setDocConsent(params).then((response: { success: Boolean }) => {
      this.updatingSettings = false;
      if (response.success) {
        this.settingsWereChanged = true;
      }
    })
  }

  closeModal () {
    this.activeModal.close(this.user);
  }
}
